// extracted by mini-css-extract-plugin
export default {"texterror":"UploadMaterialModal_texterror__DelRY","current_file":"UploadMaterialModal_current_file__GLB+p","uploadSuccess":"UploadMaterialModal_uploadSuccess__oHltr"};